export default __webpack_public_path__ + "static/media/website legend.ffd350ea.png";